import React, { useState,useEffect } from 'react';
import axios from './axios';
import './Row.css';
import YouTube from 'react-youtube';
// Using react youtube to show youtube stuff here
// Passing it video id and opts(Options) as parameters

import movieTrailer from 'movie-trailer';
// Trying to fetch movie trailer link from youtube
// By name

const baseUrl='https://image.tmdb.org/t/p/original/';

const Row = ({title,fetchUrl,isLargeRow}) => {
    
    const [movies,setMovies] =useState([]);
    const [trailerUrl,setTrailerUrl]=useState('');

    useEffect(()=>{

        async function fetchData(){
            
            const request = await axios.get(fetchUrl);
            setMovies(request.data.results);
            return request;
        }

        fetchData();

    },[fetchUrl]);

    // Setting options for youtube video here
    const opts={
        height:'390',
        width:'100%',
        playerVars:{
            autoplay:1
        }
    }

    const handleClick=(movie)=>{

        // If the trailer is initialy opened close it
        if(trailerUrl){
            setTrailerUrl('');
        }
        else{
            // Getting the link by using the movie name
            movieTrailer(movie?.title||movie?.name||movie?.original_name||"")
            .then((url)=>{//It return a url
                const urlParams=new URLSearchParams(new URL(url).search)
                setTrailerUrl(urlParams.get('v'));
                // Getting that video id from above and setting
                // It as TrailerUrl string to pass it in youtube Container
            }).catch(error=>{console.log(error)})
        }

    }

    
    return (
        <div className="row">
            {/* TITLE */}
            <h2>{title}</h2>
            
            <div className='row__posters'>
                {
                    movies.map((movie)=>(
                        <img 
                        key={movie.id}
                        onClick={()=> handleClick(movie)}
                        src={`${baseUrl}${isLargeRow? movie.poster_path : movie.backdrop_path}`}
                        alt={movie.name}
                        className={`row__poster ${isLargeRow && 'row__posterLarge'}`}
                        />
                    ))
                }
            </div>
            {
                trailerUrl && <YouTube videoId={trailerUrl} opts={opts}/>
            }
            
        </div>
    )
}

export default Row
